// Template206: Osaka - Castillo de Osaka (Día 1, parte 1)
// Equivalente a Page6.jsx de guia-osaka. Datos desde page (backend).

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template206 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const titleOverlay = page?.texts?.[1]?.content;
	const intro = page?.texts?.[2]?.content;
	const block1Title = page?.texts?.[3]?.content;
	const block1Body = page?.texts?.[4]?.content;
	const block2Title = page?.texts?.[5]?.content;
	const block2Body = page?.texts?.[6]?.content;
	const tipEntrada = page?.texts?.[7]?.content;
	const tipPrimavera = page?.texts?.[8]?.content;
	const listItem2 = page?.texts?.[9]?.content;
	const listItem3 = page?.texts?.[10]?.content;
	const llegarTitle = page?.texts?.[11]?.content;
	const llegarContent = page?.texts?.[12]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const castillo2Image = getImageSrc("castillo2");
	const parqueImage = getImageSrc("parque");
	const primaveraImage = getImageSrc("primavera");
	const portadaSticker = getCanvasImageUrl("portada-sticker");
	const sticker2 = getCanvasImageUrl("sticker2");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const sabiasQueLlegar = Array.isArray(page?.data?.sabiasQueLlegar)
		? page.data.sabiasQueLlegar
		: [];

	const actualHeaderColor = headerBackgroundColor || "#1F4E3D";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};

	const contentColor = textColor || "#444";

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: contentColor,
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			{/* CABECERA */}
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{/* IMAGEN PORTADA */}
			<Box data-block-id="image-0" sx={{ position: "relative" }}>
				{portadaImage && (
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
				)}
				{titleOverlay && (
					<Box
						component="h1"
						sx={{
							fontSize: 30,
							textAlign: "center",
							position: "absolute",
							bottom: -5,
							left: 20,
							color: "#fff",
							textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
						}}
					>
						{titleOverlay}
					</Box>
				)}
				{portadaSticker && (
					<Box
						component="img"
						src={portadaSticker}
						alt=""
						sx={{ width: 90, position: "absolute", bottom: 60, left: 20 }}
					/>
				)}
			</Box>

			<Box data-block-id="text-1" sx={{ padding: "10px 12px", flex: 1, position: "relative" }}>
				{intro && (
					<Box
						sx={{
							fontSize: 13,
							color: "#333",
							marginBottom: 1.5,
							marginTop: "-10px",
						}}
					>
						{intro}
					</Box>
				)}

				{/* BLOQUE 1: Castillo de Osaka */}
				<Box
					data-block-id="text-2"
					sx={{
						display: "flex",
						alignItems: "flex-start",
						gap: 2,
						position: "relative",
					}}
				>
					{castillo2Image && (
						<Box
							component="img"
							src={castillo2Image}
							alt=""
							sx={{
								width: "40%",
								height: 110,
								borderRadius: "12px",
								objectFit: "cover",
							}}
						/>
					)}
					{sabiasQue.length > 0 && (
						<Box
							sx={{
								position: "absolute",
								bottom: isSmallScreen ? 80 : 0,
								left: "33%",
							}}
						>
							<SabiasQue
								icono={sabiasQue[0]?.icono ?? "🏯"}
								texto={sabiasQue[0]?.texto ?? ""}
							/>
						</Box>
					)}
					<Box sx={{ width: "60%" }}>
						{block1Title && (
							<Box component="h3" sx={estiloH3}>
								{block1Title}
							</Box>
						)}
						{block1Body && (
							<Box component="p" sx={estiloP}>
								{block1Body}
							</Box>
						)}
					</Box>
				</Box>

				{/* BLOQUE 2: Parque Nishinomaru + tip entrada */}
				<Box
					data-block-id="text-3"
					sx={{
						display: "flex",
						alignItems: "flex-start",
						gap: 2,
						marginTop: 1.5,
						position: "relative",
					}}
				>
					{sticker2 && (
						<Box
							component="img"
							src={sticker2}
							alt=""
							sx={{ width: 90, position: "absolute", bottom: 30, left: -20 }}
						/>
					)}
					{tipEntrada && (
						<Box
							sx={{
								position: "absolute",
								bottom: 100,
								left: isSmallScreen ? -10 : 0,
								backgroundColor: "#fff8db",
								border: "2px solid #f5c400",
								borderRadius: "16px 16px 16px 0px",
								padding: "10px 12px",
								fontSize: 11,
								color: contentColor,
								boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
								maxWidth: 140,
							}}
							dangerouslySetInnerHTML={{ __html: tipEntrada }}
						/>
					)}
					{parqueImage && (
						<Box
							component="img"
							src={parqueImage}
							alt=""
							sx={{
								width: "40%",
								height: 110,
								borderRadius: "12px",
								objectFit: "cover",
							}}
						/>
					)}
					<Box sx={{ width: "60%" }}>
						{block2Title && (
							<Box component="h3" sx={estiloH3}>
								{block2Title}
							</Box>
						)}
						{block2Body && (
							<Box component="p" sx={estiloP}>
								{block2Body}
							</Box>
						)}
					</Box>
				</Box>

				{/* Lista + primavera tip */}
				<Box data-block-id="text-4" sx={{ position: "relative", marginTop: 1 }}>
					<ul
						style={{
							fontSize: 13,
							paddingLeft: 20,
							color: contentColor,
							fontFamily: "inherit",
							marginBottom: 12,
						}}
					>
						{primaveraImage && (
							<li style={{ listStyle: "none", marginBottom: 8 }}>
								<Box
									sx={{
										width: isSmallScreen ? 115 : 90,
										float: "right",
										position: "relative",
									}}
								>
									<Box
										component="img"
										src={primaveraImage}
										alt=""
										sx={{
											width: 100,
											marginLeft: 3.5,
											marginTop: isSmallScreen ? 10 : 5,
										}}
									/>
									{tipPrimavera && (
										<Box
											sx={{
												backgroundColor: "#fff8db",
												border: "2px solid #f5c400",
												borderRadius: "16px 16px 0px 16px",
												padding: "10px 12px",
												fontSize: 11,
												color: contentColor,
												boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
												maxWidth: 180,
												position: "absolute",
												top: isSmallScreen ? 100 : 78,
												left: -4,
												transform: "translateY(-100%)",
											}}
											dangerouslySetInnerHTML={{ __html: tipPrimavera }}
										/>
									)}
								</Box>
							</li>
						)}
						{listItem2 && (
							<li
								style={{ marginBottom: 8 }}
								dangerouslySetInnerHTML={{ __html: listItem2 }}
							/>
						)}
						{listItem3 && (
							<li
								style={{ marginBottom: 8 }}
								dangerouslySetInnerHTML={{ __html: listItem3 }}
							/>
						)}
					</ul>
					{sabiasQueLlegar.length > 0 && (
						<Box
							sx={{
								position: "absolute",
								bottom: isSmallScreen ? -40 : 90,
								right: "33%",
							}}
						>
							<SabiasQue
								icono={sabiasQueLlegar[0]?.icono ?? "🏗️"}
								texto={sabiasQueLlegar[0]?.texto ?? ""}
							/>
						</Box>
					)}
				</Box>

				{/* Cómo llegar */}
				{(llegarTitle || llegarContent) && (
					<Box
						data-block-id="text-5"
						sx={{
							backgroundColor: "#d1e6de",
							border: "3px solid #1F4E3D",
							borderRadius: "12px",
							padding: "12px 18px",
							fontSize: 12,
							color: "#333",
							marginTop: 0,
						}}
					>
						{llegarTitle && (
							<Box
								component="h4"
								sx={{
									margin: 0,
									marginBottom: 1,
									fontSize: 13,
									fontWeight: 700,
									display: "flex",
									alignItems: "center",
									gap: 0.75,
									color: contentColor,
									textTransform: "uppercase",
								}}
							>
								{llegarTitle}
							</Box>
						)}
						{llegarContent && (
							<Box
								component="ul"
								sx={{ paddingLeft: 2.5, margin: 0, lineHeight: 1.5 }}
								dangerouslySetInnerHTML={{ __html: llegarContent }}
							/>
						)}
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template206.thumbnail = "/images/template-1.png";

export default Template206;
